/** A saved AI change is not retried when the local task snapshot cannot refresh. */
export async function refreshAITaskViews(): Promise<string | null> {
  try {
    const { DataService } = await import('../../services/DataService');
    await DataService.refreshFromBackend(true);
    if (DataService.getDataSyncState().error) throw new Error('Task snapshot refresh failed');
    window.dispatchEvent(new CustomEvent('project-tasks:refresh'));
    window.dispatchEvent(new CustomEvent('calendar:reload'));
    return null;
  } catch {
    return 'The change was saved, but Calendar could not refresh. Reload Calendar to see the latest schedule.';
  }
}
